import { render, staticRenderFns } from "./InformationPanelUser.vue?vue&type=template&id=5a7e1949&scoped=true&lang=pug&"
import script from "./InformationPanelUser.vue?vue&type=script&lang=ts&"
export * from "./InformationPanelUser.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPanelUser.vue?vue&type=style&index=0&id=5a7e1949&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7e1949",
  null
  
)

export default component.exports